import { debounce, upperFirst, lowerCase } from 'lodash';
import { api, formatToLocalDate, formatToIsoDate } from '@/utils';

export default {
  name: 'CargoInfo',
  components: {},
  props: {
    inputForm: {
      type: Object,
      default: undefined,
    },
    inputFormType: {
      type: String,
      default: '',
    },
    ports: {
      type: Array,
      default: [],
    },
    enums: {
      type: Array,
      default: [],
    },
    products: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    apiVersion: 1,
    showConfirm: false,
    cargoIndexIdToDelete: null,
    // activityEventCargoIndex is used to know on which cargo we need to delete the activity event
    activityEventCargoIndex: null,
    activityEventIndexIdToDelete: null,
    cargoes: [],
    formFields: {
      type: {
        name: 'type',
        label: 'Cargo operation',
        validation: 'required',
      },
      firstDatepickerEtStart: {
        name: 'firstDatepickerEtStart',
        label: '',
      },
      firstDatepickerEtEnd: {
        name: 'firstDatepickerEtEnd',
        label: '',
      },
      firstDatepickerAtStart: {
        name: 'firstDatepickerAtStart',
        label: '',
      },
      firstDatepickerAtEnd: {
        name: 'firstDatepickerAtEnd',
        label: '',
      },
      secondDatepickerEtStart: {
        name: 'secondDatepickerEtStart',
        label: 'Vapor time ET start',
      },
      secondDatepickerEtEnd: {
        name: 'secondDatepickerEtEnd',
        label: 'Vapor time ET end',
      },
      secondDatepickerAtStart: {
        name: 'secondDatepickerAtStart',
        label: 'Vapor time At start',
      },
      secondDatepickerAtEnd: {
        name: 'secondDatepickerAtEnd',
        label: 'Vapor time At end',
      },
      reference: {
        name: 'reference',
        label: 'Reference',
      },
      sequence: {
        name: 'sequence',
        label: 'Sequence',
      },
      remarks: {
        name: 'remarks',
        label: 'Remarks',
      },
      connectionResponsibleStakeholder: {
        name: 'connectionResponsibleStakeholder',
        label: 'Connection responsible stakeholder',
      },
      portOfLoading: {
        name: 'portOfLoading',
        label: 'Port of loading',
      },
      portOfDischarge: {
        name: 'portOfDischarge',
        label: 'Port of discharge',
      },
      content: {
        name: 'content',
        label: 'Content',
        validation: 'required',
      },
      quantity: {
        name: 'quantity',
        label: 'Quantity',
      },
      quantityUnit: {
        name: 'quantityUnit',
        label: 'Quantity unit',
      },
      isHeated: {
        name: 'isHeated',
        label: 'Is heated',
      },
      temperatureCelcius: {
        name: 'temperatureCelcius',
        label: 'Temperature celcius',
      },
      tankCount: {
        name: 'tankCount',
        label: 'Tank count',
      },
      requiredConnectionType: {
        name: 'requiredConnectionType',
        label: 'Required connection type',
      },
      doVapors: {
        name: 'doVapors',
        label: 'Do vapors',
      },
      vaporsDurationHours: {
        name: 'vaporsDurationHours',
        label: 'Vapors duration hours',
      },
      activityEvents: {
        name: 'activityEvents',
        label: 'Activity events',
      },
      activityEventType: {
        name: 'activityEventType',
        label: 'Type',
      },
      activityEventDate: {
        name: 'activityEventDate',
        label: 'Date',
      },
    },
    // search props
    pageSize: 10,
    selectedClient: null,
    searchClient: null,
    isLoadingClient: false,
    stakeholderEntries: [],
  }),
  computed: {
    show() {
      return this.inputFormType === 'CargoOperations';
    },
    cargoTypeDropdownValues() {
      return this.enums.length > 0 && this.enums.find(e => e.name === 'CargoOperation') != null ? this.enums.find(e => e.name === 'CargoOperation').values : [];
    },
    quantityUnitDropdownValues() {
      return this.enums.length > 0 && this.enums.find(e => e.name === 'CargoUnit') != null ? this.enums.find(e => e.name === 'CargoUnit').values : [];
    },
    vesselImoClassDropdownValues() {
      return this.enums.length > 0 && this.enums.find(e => e.name === 'VesselImoClass') != null ? this.enums.find(e => e.name === 'VesselImoClass').values : [];
    },
    activityEventTypeDropdownValues() {
      const activityEventTypeEnums = this.enums.length > 0 && this.enums.find(e => e.name === 'ActivityEventType') != null ? this.enums.find(e => e.name === 'ActivityEventType').values : [];

      if (activityEventTypeEnums.lenght === 0) {
        return [];
      }

      const activityEventTypeEnumsByInputFormType = activityEventTypeEnums.filter(aete => aete.includes(this.inputFormType));
      const activityEventTypeEnumsByInputFormTypeFormatted = activityEventTypeEnumsByInputFormType.map((entry) => {
        const entryWithoutInputFormType = entry.replace(this.inputFormType, '');
        const entryWithoutInputFormTypeFormatted = upperFirst(lowerCase(entryWithoutInputFormType));
        return {
          name: entryWithoutInputFormTypeFormatted,
          value: entry,
        };
      });

      return activityEventTypeEnumsByInputFormTypeFormatted;
    },
  },
  methods: {
    addCargo() {
      const cargo = {
        type: '',
        firstDatepickerEtStart: null,
        firstDatepickerEtEnd: null,
        firstDatepickerAtStart: null,
        firstDatepickerAtEnd: null,
        secondDatepickerEtStart: null,
        secondDatepickerEtEnd: null,
        secondDatepickerAtStart: null,
        secondDatepickerAtEnd: null,
        reference: '',
        sequence: this.cargoes.length + 1,
        remarks: '',
        selectedClient: null,
        portOfLoading: null,
        portOfDischarge: null,
        content: null,
        quantity: 0,
        quantityUnit: this.quantityUnitDropdownValues[0],
        isHeated: false,
        temperatureCelcius: 0,
        tankCount: 0,
        requiredConnectionType: '',
        doVapors: false,
        vaporsDurationHours: 0,
        activityEvents: [{
          activityEventType: '',
          activityEventDate: null,
        }],
      };

      this.cargoes.push(cargo);
    },
    setConfirm(index) {
      this.cargoIndexIdToDelete = index;
      this.showConfirm = true;
    },
    setClients() {
      this.cargoes.forEach((cargo) => {
        if (cargo.connectionResponsibleStakeholderId != null) {
          // BASEURL
          const url = `/stakeholders/${cargo.connectionResponsibleStakeholderId}`;

          api.get(url)
            .then((response) => {
              /* eslint-disable */
              cargo.selectedClient = response.data;
              this.stakeholderEntries.push(response.data);
            })
            .catch((error) => {
              console.log(error);
            });
        }
      });
    },
    cancelConfirm() {
      this.cargoIndexIdToDelete = null;
      this.activityEventIndexIdToDelete = null;
      this.showConfirm = false;
    },
    deleteItem() {
      if (this.cargoIndexIdToDelete != null) {
        this.cargoes.splice(this.cargoIndexIdToDelete, 1);
      }
      if (this.activityEventIndexIdToDelete != null) {
        this.cargoes[this.activityEventCargoIndex].activityEvents.splice(this.activityEventIndexIdToDelete, 1);
      }
      this.showConfirm = false;
    },
    searchStakeholder: debounce(function fetchStakeHolders() {
      this.isLoadingClient = true;

      // BASEURL
      let url = `/stakeholders?`;

      // Name
      url += `name=${this.searchClient}`;

      // Page and Pagesize
      url += `&page=1&page-size=${this.pageSize}`;

      api.get(url)
        .then((response) => {
          this.stakeholderEntries = response.data;
          this.isLoadingClient = false;
        })
        .catch((error) => {
          console.log(error);
        });
    }, 300),
    // Activity event
    addActivityEvent(index) {
      const activityEvent = {
        activityEventType: '',
        activityEventDate: null,
      };

      this.cargoes[index].activityEvents.push(activityEvent);
    },
    setConfirmActivityEvent(cargoIndex, activityEventIndex) {
      this.activityEventCargoIndex = cargoIndex;
      this.activityEventIndexIdToDelete = activityEventIndex;
      this.showConfirm = true;
    },
    onInputFormSaved() {
      this.$validator.validateAll()
        .then((isValid) => {
          if (isValid) {
            this.sendInputForm();
          } else {
            this.$eventHub.$emit('fetch-cargo-info', false);
          }
        })
        .catch((error) => {
          console.log(error);
          console.log('something went wrong in file CargoInfo.controller.js method onInputFormSaved');
        });
    },
    sendInputForm() {
      if (this.inputFormType !== 'CargoOperations') {
        this.$eventHub.$emit('fetch-cargo-info', null);
      } else {
        const postObject = [];
        this.cargoes.forEach((cargo) => {
          const cargoToPost = {
            reference: cargo.reference,
            sequence: cargo.sequence,
            remarks: cargo.remarks,
            connectionResponsibleStakeholderId: cargo.selectedClient != null ? cargo.selectedClient.id : null,
            portOfLoading: cargo.portOfLoading,
            portOfDischarge: cargo.portOfDischarge,
            content: cargo.content !== '' ? cargo.content : null,
            quantity: cargo.quantity,
            quantityUnit: cargo.quantityUnit,
            operation: cargo.type,
            loadingWindow: {},
            dischargeWindow: {},
            vaporsWindow: {},
            isHeated: cargo.isHeated,
            temperatureCelcius: parseFloat(cargo.temperatureCelcius),
            tankCount: cargo.tankCount,
            requiredConnectionType: cargo.requiredConnectionType,
            doVapors: cargo.doVapors,
            vaporsDurationHours: parseInt(cargo.vaporsDurationHours),
          };

          const activityEventsObject = [];
          cargo.activityEvents.forEach((activityEvent) => {
            if (activityEvent.activityEventType !== '' && activityEvent.activityEventDate !== null) {
              const activityEventObject = {
                activityEventType: activityEvent.activityEventType,
                activityEventDate: formatToIsoDate(activityEvent.activityEventDate),
              };

              activityEventsObject.push(activityEventObject);
            }
          });
          cargoToPost.activityEvents = activityEventsObject;

          if (cargo.type === 'Discharging') {
            cargoToPost.dischargeWindow.beginEstimate = formatToIsoDate(cargo.firstDatepickerEtStart);
            cargoToPost.dischargeWindow.endEstimate = formatToIsoDate(cargo.firstDatepickerEtEnd);
            cargoToPost.dischargeWindow.beginActual = formatToIsoDate(cargo.firstDatepickerAtStart);
            cargoToPost.dischargeWindow.endActual = formatToIsoDate(cargo.firstDatepickerAtEnd);

            if (cargo.doVapors) {
              cargoToPost.vaporsWindow.beginEstimate = formatToIsoDate(cargo.secondDatepickerEtStart);
              cargoToPost.vaporsWindow.endEstimate = formatToIsoDate(cargo.secondDatepickerEtEnd);
              cargoToPost.vaporsWindow.beginActual = formatToIsoDate(cargo.secondDatepickerAtStart);
              cargoToPost.vaporsWindow.endActual = formatToIsoDate(cargo.secondDatepickerAtEnd);
            }
          } else if (cargo.type === 'Loading') {
            cargoToPost.loadingWindow.beginEstimate = formatToIsoDate(cargo.firstDatepickerEtStart);
            cargoToPost.loadingWindow.endEstimate = formatToIsoDate(cargo.firstDatepickerEtEnd);
            cargoToPost.loadingWindow.beginActual = formatToIsoDate(cargo.firstDatepickerAtStart);
            cargoToPost.loadingWindow.endActual = formatToIsoDate(cargo.firstDatepickerAtEnd);
          }

          postObject.push(cargoToPost);
        });

        this.$eventHub.$emit('fetch-cargo-info', postObject);
      }
    },
  },
  watch: {
    inputForm() {
      if (this.inputForm != null && this.inputForm.cargo.length > 0) {
        this.cargoes = this.inputForm.cargo.map((cargo) => {
          /* eslint-disable */
          cargo.type = cargo.operation;

          if (cargo.type === 'Discharging') {
            /* eslint-disable */
            cargo.firstDatepickerEtStart = formatToLocalDate(cargo.dischargeWindow.beginEstimate);
            cargo.firstDatepickerEtEnd = formatToLocalDate(cargo.dischargeWindow.endEstimate);
            cargo.firstDatepickerAtStart = formatToLocalDate(cargo.dischargeWindow.beginActual);
            cargo.firstDatepickerAtEnd = formatToLocalDate(cargo.dischargeWindow.endActual);


            if (cargo.doVapors) {
              cargo.secondDatepickerEtStart = formatToLocalDate(cargo.vaporsWindow.beginEstimate);
              cargo.secondDatepickerEtEnd = formatToLocalDate(cargo.vaporsWindow.endEstimate);
              cargo.secondDatepickerAtStart = formatToLocalDate(cargo.vaporsWindow.beginActual);
              cargo.secondDatepickerAtEnd = formatToLocalDate(cargo.vaporsWindow.endActual);
            }
          } else if (cargo.type === 'Loading') {
            cargo.firstDatepickerEtStart = formatToLocalDate(cargo.loadingWindow.beginEstimate);
            cargo.firstDatepickerEtEnd = formatToLocalDate(cargo.loadingWindow.endEstimate);
            cargo.firstDatepickerAtStart = formatToLocalDate(cargo.loadingWindow.beginActual);
            cargo.firstDatepickerAtEnd = formatToLocalDate(cargo.loadingWindow.endActual);
          }

          if (cargo.activityEvents.length === 0) {
            cargo.activityEvents.push({
              activityEventType: '',
              activityEventDate: null,
            });
          } else {
            cargo.activityEvents.map((activityEvent) => {
              /* eslint-disable */
              activityEvent.activityEventType = activityEvent.activityEventType;
              activityEvent.activityEventDate = formatToLocalDate(activityEvent.activityEventDate);

              return { ...activityEvent };
            });
          }

          return { ...cargo };
        });

        this.setClients();
      }
    },
    searchClient() {
      this.searchStakeholder();
    },
  },
  created() {
    this.$eventHub.$on('on-input-form-saved', this.onInputFormSaved);

    if (this.cargoes.length === 0) {
      this.addCargo();
    }
  },
};
